<div class="container">
  <div class="supplied-content" #content>
    <ng-content></ng-content>
  </div>
  <div class="default-content" *ngIf="!hasContent()">- Empty -</div>
</div>
